import FolderGatewayInterface from "../../domain/Folder/FolderGatewayInterface";
import {Folder} from '../../domain/Folder/Folder';
import FolderAndPageId from '../../domain/Folder/FolderAndPageId'
import StoreGatewayInterface from '../../domain/Store/StoreGatewayInterface';
import {ErrorResponse} from '../../domain/Api/Type'

export default class GetDetailAndStoreItUseCase
{
  public fileGatewayInterface;
  public storeGateway;

  constructor(FileGatewayInterface: FolderGatewayInterface, StoreGateway: StoreGatewayInterface) {
    this.fileGatewayInterface = FileGatewayInterface;
    this.storeGateway = StoreGateway;
  }

  execute(folderId: string): Promise<FolderAndPageId|null> {
    return this.fileGatewayInterface.getFolder(folderId)
      .then((response) => {
        let folderStatus: string[] = []
        if (response.dossier.status && typeof response.dossier.status === 'string') {
          folderStatus.push(response.dossier.status as string)
        } else if (Array.isArray(response.dossier.status)) {
          folderStatus = response.dossier.status
        }
        const folder = new Folder(
          response.dossier.id,
          response.dossier.form_id,
          response.dossier.client_id,
          response.dossier.advisor_id,
          response.dossier.last_submitted_block_id,
          response.dossier.values,
          response.dossier.direct,
          response.dossier.receipts,
          response.dossier.authorized_clients,
          folderStatus,
          response.correction,
          response.unable_to_review_correction
        )

        const folderAndPageId = new FolderAndPageId(folder, response.page_id, this.getUrl(folder, response.page_id))

        this.storeGateway.save(folder.values)
        this.storeGateway.saveDirect(folder.direct ? folder.direct : false)
        this.storeGateway.saveClientId(folder.client_id)
        this.storeGateway.saveReceipts(folder.receipts)
        this.storeGateway.saveAuthorizedClients(folder.authorizedClients)
        this.storeGateway.saveAdvisorId(folder.advisor_id)
        this.storeGateway.saveInvalidElements(folder.errors)
        this.storeGateway.saveToReSign(null)
        this.storeGateway.saveUnablePlateformToCorrect(folder.unableToCorrect)

        if (response.correction) {
          const toReSign = response.correction?.some(element => element.receipt_id === null);
          this.storeGateway.saveToReSign(toReSign)
          return new FolderAndPageId(folder, response.correction[0].page_id, this.getUrl(folder, response.correction[0].page_id, response.correction[0].block_id))
        }

        return folderAndPageId
      });
  }

  getUrl(folder: Folder, pageId: string, blockId?: string): string {
    let url = `/dossier/${folder.id}/form`

    if (null !== pageId) {
      url += `/${pageId}`

      const effectiveBlockId = blockId ?? folder.last_submitted_block_id
      if (null !== effectiveBlockId) {
        url += `/${effectiveBlockId}`
      }
    }

    return url
  }

  downloadSignedDocument(folderId: string): Promise<Blob> {
    return this.fileGatewayInterface.downloadSignedFolderDocument(folderId)
      .then((blob: Blob) => {
        return blob
      })
      .catch((errors: ErrorResponse) => {
        return Promise.reject(errors)
      });
  }

  getFolderDocuSignHistory(folderId: string): Promise<Blob> {
    return this.fileGatewayInterface.folderDocuSignHistory(folderId)
      .then((blob: Blob) => {
        return blob
      })
      .catch((error) => {
        return Promise.reject(error)
      });
  }

  downloadSignatureProof(folderId: string): Promise<Blob> {
    return this.fileGatewayInterface.downloadSignatureProof(folderId)
      .then((blob: Blob) => {
        return blob
      })
      .catch((errors: ErrorResponse) => {
        return Promise.reject(errors)
      });
  }
}
